// 手机号
export const mPattern = /^1[0-9]\d{9}$/;
// 正整数正则
export const posPattern = /^\d+$/;
// 正浮点数正则
export const numPattern = /^\d*\.?\d+$/;
// QQ号正则
export const qqParttern = /^\s*[.0-9]{5,11}\s*$/;
// 密码强度正则
export const passParttern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d][\w_]{6,}$/;
// Email地址正则
export const emailParttern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
// 车牌号
export const carParttern = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z]([A-Z0-9]{5}|[A-Z0-9]{6}))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
// /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;

// 不能为空
export const blankParttern = /^\s*$/;
// 身份证正则
export const idParttern = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
